<template>
<transition>
    <keep-alive include="LogOrder">
        <router-view></router-view>
    </keep-alive>

    </transition>
</template>

<script>

export default {
    name: 'LogMain'
}
</script>
